import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Topbar from '../../components/Bar/Topbar'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'

import { useParams } from 'react-router-dom'
import FormulaireReserve from '../../components/CarParc/FormulaireReserve'



const ReservationAuto = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
   const { titre } = useParams();
  return (
    <motion.div
    className=''
      style={{background:'#000'}}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
      <Topbar />
      <Header />
     
       <FormulaireReserve  />
    
     
      <Footer />
    </motion.div>
  )
}

export default ReservationAuto
